import axiosInstance from "../api/apiInterceptor";
import { AxiosResponse } from "axios";
import { TeacherAttendance } from "../types/teacherAtteandance";
import { TEACHER_ATTENDANCE_API_ENDPOINT } from "../../../constants/constants";

// Define the filter payload interface (adjust fields based on your API requirements)
interface TeacherAttendancePayload {
  schoolId: number;
  attnDate: string; // Now mandatory
  classSectionId?: number; // Optional
  teacherId?: number; // Optional
}

// Service function to fetch teacher attendance
export const fetchTeacherAttendanceApi = async (
  payload: TeacherAttendancePayload
): Promise<TeacherAttendance[]> => {
  try {
    let url = `${TEACHER_ATTENDANCE_API_ENDPOINT}`;

    // Construct filter string in the format: key|value,key2|value2
    const filterParams: string[] = [];
    if (payload.schoolId) {
      filterParams.push(`schoolId|${payload.schoolId}`);
    }
    if (payload.attnDate) {
      filterParams.push(`attnDate|${payload.attnDate}`);
    } else {
      throw new Error("attnDate is required");
    }
    if (payload.classSectionId) {
      filterParams.push(`classSectionId|${payload.classSectionId}`);
    }
    if (payload.teacherId) {
      filterParams.push(`teacherId|${payload.teacherId}`);
    }

    // Build the URL with filter query parameter
    if (filterParams.length > 0) {
      url += `?filter=${filterParams.join(',')}`; // e.g., ?filter=schoolId|123,attnDate|2025-07-19
    }

    // Make GET request using axiosInstance
    const response: AxiosResponse<any> = await axiosInstance.get(url);

    // Return the attendance data (adjust based on your API response structure)
    return response.data.data || response.data || [];
  } catch (error: any) {
    // Log error for debugging
    console.error('Error fetching Teacher Attendance:', error);

    // Throw a simple error message
    throw new Error(error.message || 'Failed to fetch teacher attendance');
  }
};
export const checkInTeacherAttnApi = async (TeacherAttn: TeacherAttendance): Promise<TeacherAttendance> => {
  try {
    const response: AxiosResponse<TeacherAttendance> = await axiosInstance.post(`${TEACHER_ATTENDANCE_API_ENDPOINT}`, TeacherAttn);
    return response.data;
  } catch (error: any) {
    console.error('Error updating Teacher:', error);
    console.log("error", error.message || error?.response?.data?.message);
    throw new Error(error?.response?.data?.message || error.message || 'Failed to fetch teacher attendance');
  }
};
export const checkOutTeacherAttnApi = async (TeacherAttn: TeacherAttendance): Promise<TeacherAttendance> => {
  try {
    const response: AxiosResponse<TeacherAttendance> = await axiosInstance.patch(`${TEACHER_ATTENDANCE_API_ENDPOINT}/${TeacherAttn.id}`, TeacherAttn);
    return response.data;
  } catch (error: any) {
    console.error('Error updating Teacher:', error);
    throw new Error(error.message || 'Failed to fetch teacher attendance');
  }
};